import Icon from './Icon';
import { useIsMobile } from '../utils/useIsMobile';

export default function FoodCostIcon() {
  const isMobile = useIsMobile(640);
  return (
    <span className="food-cost-icon" role="img" aria-label="חלק מה-Food Cost"
      title={isMobile ? undefined : 'חלק מה-Food Cost'}>
      <Icon name="restaurant" size={14} />
    </span>
  );
}
